import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import GridContainer from '../../../../@jumbo/components/GridContainer';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { Collapse, fade, IconButton, Link } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';

import CmtImage from '../../../../@coremat/CmtImage';

import IntlMessages from '../../../utils/IntlMessages';
import { AuhMethods } from '../../../../services/auth';
import ContentLoader from '../../ContentLoader';
import { CurrentAuthMethod } from '../../../constants/AppConstants';
import AuthWrapper from './AuthWrapper';
import { setForgetPassMailSent } from '../../../../redux/actions/Auth';

const useStyles = makeStyles(theme => ({
  authThumb: {
    backgroundColor: fade(theme.palette.primary.main, 0.12),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    [theme.breakpoints.up('md')]: {
      width: '50%',
      order: 2,
    },
  },
  authContent: {
    padding: 30,
    [theme.breakpoints.up('md')]: {
      order: 1,
      width: props => (props.variant === 'default' ? '50%' : '100%'),
    },
    [theme.breakpoints.up('xl')]: {
      padding: 50,
    },
  },
  titleRoot: {
    marginBottom: 14,
    color: theme.palette.text.primary,
  },
  textFieldRoot: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: fade(theme.palette.common.dark, 0.12),
    },
  },
  alertRoot: {
    marginBottom: 10,
  },
}));

//variant = 'default', 'standard', 'bgColor'
const ForgotPassword = ({ method = CurrentAuthMethod, variant = 'default', wrapperVariant = 'default' }) => {
  const { send_forget_password_email } = useSelector(({ auth }) => auth);
  const [open, setOpen] = React.useState(false);
  const [email, setEmail] = useState('demo@example.com');
  const dispatch = useDispatch();
  const classes = useStyles({ variant });
  const history = useHistory();

  useEffect(() => {
    let timeOutStopper = null;
    if (send_forget_password_email) {
      setOpen(true);

      timeOutStopper = setTimeout(() => {
        dispatch(setForgetPassMailSent(false));
        history.push('/');
      }, 1500);
    }

    return () => {
      if (timeOutStopper) clearTimeout(timeOutStopper);
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [send_forget_password_email]);

  const onSubmit = () => {
    dispatch(AuhMethods[method].onForgotPassword({ email }));
  };
  var brandId = 0;
  var emailLink = 'mailto:info@webbookingpro.com';
  var hostName = window.location.hostname;
  if (hostName === 'app.mikos.io' || hostName === 'app.forotel.io') {
    brandId = 1;
    emailLink = 'mailto:info@forotel.com';
  }
  if (hostName === 'book.serenahotels.com') {
    brandId = 2;
    emailLink = 'mailto:it.kenya@serenahotels.com';
  }
  if (brandId == 0) document.title = 'WebBookingPro';
  if (brandId == 1) document.title = 'forotel';
  if (brandId == 2) document.title = 'forotel';

  return (
    <AuthWrapper variant={wrapperVariant}>
      {variant === 'default' ? (
        <div className={classes.authThumb}>
          <CmtImage src={'/images/auth/forgot-img.png'} />
        </div>
      ) : null}
      <div className={classes.authContent}>
        <div className={'mb-7'}>
          <GridContainer>
            <Grid
              container
              xs={12}
              sm={12}
              xl={12}
              direction="row"
              alignContent="center"
              alignItems="center"
              justify="center">
              {brandId == 0 && <CmtImage src={'/images/webbookingpro_logo.png'} />}
              {brandId == 2 && (
                <img
                  src="https://cdn.webbookingpro.com/images/hotels/hotellogo_33856_aqo19aolmel7jork3i6z.jpg"
                  style={{ paddingRight: '20px', maxHeight: '120px' }}
                />
              )}
              {brandId == 1 && (
                <>
                  <img
                    src="https://cdn.webbookingpro.com/forotel/sophiasurge_logo.png"
                    style={{ paddingRight: '20px', maxWidth: '25%', maxHeight: '96px' }}
                  />
                  <img
                    src="https://cdn.webbookingpro.com/forotel/lunalink_logo.png"
                    style={{ paddingRight: '20px', maxWidth: '25%', maxHeight: '96px' }}
                  />
                  <img
                    src="https://cdn.webbookingpro.com/forotel/zoezoom_logo.png"
                    style={{ maxWidth: '25%', maxHeight: '96px' }}
                  />
                </>
              )}
            </Grid>
          </GridContainer>
        </div>
        <Typography component="div" variant="h1" className={classes.titleRoot}>
          ForgotPassword
        </Typography>
        <Collapse in={open}>
          <Alert
            variant="outlined"
            severity="success"
            className={classes.alertRoot}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setOpen(false);
                }}>
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }>
            A mail has been sent on your email address with reset password link. If you haven't received email within one
            minute, please check your Spam/Junk folder.
          </Alert>
        </Collapse>
        <form>
          <div className={'mb-5'}>
            <TextField
              label={<IntlMessages id="appModule.email" />}
              fullWidth
              onChange={event => setEmail(event.target.value)}
              defaultValue={email}
              margin="normal"
              variant="outlined"
              className={classes.textFieldRoot}
            />
          </div>
          <div className={'mb-5'}>
            <Button fullWidth="true" onClick={onSubmit} variant="contained" color="primary">
              <IntlMessages id="appModule.resetPassword" />
            </Button>
          </div>

          <div>
            <Typography>
              Don't remember your email?
              <span className={'ml-2'}>
                <Link href={emailLink}>
                  <IntlMessages id="appModule.contactSupport" />
                </Link>
              </span>
            </Typography>
          </div>
        </form>
        <ContentLoader />
      </div>
    </AuthWrapper>
  );
};

export default ForgotPassword;
